export enum SsoProvider {
  EntraId = 0,
}

export const SsoProviderLookup: Record<SsoProvider, string> = {
  [SsoProvider.EntraId]: "Microsoft Entra ID",
};

export enum SsoUserProvisioningMode {
  AutoProvision = 0,
  PreProvision = 1,
}

export const SsoUserProvisioningModeLookup: Record<
  SsoUserProvisioningMode,
  string
> = {
  [SsoUserProvisioningMode.AutoProvision]: "Auto-provision",
  [SsoUserProvisioningMode.PreProvision]: "Pre-provision",
};

export interface ISsoConfigResponse {
  id: string;
  customerId: string;
  provider: SsoProvider;
  tenantId: string;
  clientId: string;
  hasClientSecret: boolean;
  enabled: boolean;
  autoRedirect: boolean;
  userProvisioningMode: SsoUserProvisioningMode;
}

export interface CreateUpdateSsoConfigRequest {
  provider: SsoProvider;
  tenantId: string;
  clientId: string;
  clientSecret?: string;
  enabled: boolean;
  autoRedirect: boolean;
  userProvisioningMode: SsoUserProvisioningMode;
}
